export default __webpack_public_path__ + "static/O0159-0fd626e09f2838b482685f6dc4ef5b3a.png";